module.exports = __webpack_public_path__ + "img/aupply_01.1a4bd371.jpg";